module.exports = __webpack_public_path__ + "img/15_55.5d0ba8ef.png";